import { createFileRoute } from '@tanstack/react-router';
import { InvitePage } from '@pages/invite';
import { PageTransition } from '@ui';

export const Route = createFileRoute('/invite')({
  validateSearch: (search: Record<string, unknown>): { invite_token?: string; token?: string } => ({
    ...(typeof search.invite_token === 'string' && search.invite_token
      ? { invite_token: search.invite_token }
      : {}),
    ...(typeof search.token === 'string' && search.token ? { token: search.token } : {}),
  }),
  component: InviteRoute,
});

function InviteRoute() {
  return (
    <PageTransition>
      <InvitePage />
    </PageTransition>
  );
}
